module.exports = __webpack_public_path__ + "img/tips-note.c0f3ea4e.svg";